import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/SimpleAuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * Protected route component
 * 
 * Ensures that only authenticated users can access protected routes
 * Shows loading indicator while checking authentication
 * Redirects to login if not authenticated
 */
export const SimpleProtectedRoute: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading indicator while checking authentication
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Render children if authenticated
  return <>{children}</>;
};
